module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAYCAMAAADEfo0+AAAAdVBMVEVHcEze3t7c3Nzc3Nzd3d3d3d3c3Ny/v7/d3d3b29vd3d3d3d3c3Nzb29ve3t7d3d3d3d3d3d3d3d3d3d3f39/d3d3d3d3d3d3c3NzV1dXc3NzY2Njc3Nzd3d3c3Nzd3d3d3d3e3t7d3d3d3d3f39/d3d3d3d1jZ6MHAAAAJnRSTlMAodaE9WpnBP0OvdUdMk3ohkr3HjD+edmTBsANM+miu+pGvKNHNB31JiMAAACISURBVBjTfdA3EoQwEERRPMKDhF8DrJn7H5HOpklQ9n51MCXPu3nzuFzcG5kODpuIrOQOHp7qtEB40yCBrVM/GoSWBiH8ytRlhBDTwIeDVF0ZhJoGOZyTa9hUdFOA4NMghqNSne0IIQ1auKGbnEVIaPCFC7rpPyB0NFjhD3/cbxLTX/52GWfmCfZMDQgjRr/lAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/20210517new/xg.png
// module id = MlBD
// module chunks = 14